export default "__VITE_ASSET__Cz7qy6Vm__"